import { Box, Dialog, Divider, Slide } from "@mui/material";
import axios from "axios";
import { forwardRef, useEffect, useState } from "react";
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";
import get_token from "../lib/get_token";
import { loginState, configState } from "../lib/State";
import AgreeText from "./AgreeText";
import DialogText from "./DialogText";
import RegisterConfirm from "./RegisterConfirm";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HomeFooter() {
  const cid = get_cid();
  const token = get_token();
  const [login, setLogin] = useState(loginState);
  const [openDialog, setOpenDialog] = useState(false);
  const [accordions, setAccordions] = useState([
    {
      id: 0,
      title: "예약수업은 어떻게 취소할 수 있나요?",
      content: `예약수업 취소는, 내수업 페이지의 내수업 탭에서 예약취소 버튼 클릭 시 가능합니다.
단, 당일 수업 취소는 불가능합니다. (수업 시작 1일 전까지 취소 가능)`,
      show: false,
    },
    {
      id: 1,
      title: "쿠폰은 어떻게 환불할 수 있나요?",
      content: `환불 신청은 미사용 쿠폰만 가능하며, 쿠폰 시작일로부터 7일 이내에만 가능합니다.
단, 1회권은 유효기간이 7일이므로 구매 후 3일 이내에만 환불 신청 가능합니다.
구매 쿠폰을 단 1회라도 사용했을 시, 남은 쿠폰은 환불 불가합니다.`,
      show: false,
    },
    {
      id: 2,
      title:
        "불가피한 사정으로 수업에 참석하지 못했습니다. 쿠폰 반환이 가능한가요?",
      content: `불가항력적인 사유로 예약한 클래스에 참석하지 못한 경우, 관련 증명서류를 지참하여 쿠폰 반환 신청을 할 수 있습니다.
불가항력 사유 : 천재지변, 사고, 질병, 부고 등이 해당되며 증빙서류 제출이 가능한 사유
반환 절차 : 내수업에서 만료 쿠폰 반환 신청 클릭 => 관련 증빙서류 업로드 => 해당 사유등록확인 절차 후 쿠폰 반환`,
      show: false,
    },
    {
      id: 3,
      title: "수업 예약하는 방법을 알고 싶습니다.",
      content: `1. 원하는 센터를 선택합니다.
2. 달력에서 수업을 듣고 싶은 날짜를 선택합니다(센터별로 수업시간은 상이함).
3. 달력 하단 리스트에서 원하는 수업을 고릅니다.
4. 예약 팝업에서 OK 버튼을 누르면 예약이 됩니다.

예약확인은 내수업 페이지의 내수업 탭에서 확인 가능합니다.`,
      show: false,
    },
  ]);
  const get_session = async () => {
    let result = await axios.post(configState.api + "/gympass/get_session", {
      token: token,
      cid: cid,
    });
    if (result.data.mcd !== "" && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
  };
  useEffect(() => {
    get_session();
  }, []);
  const closeDialog = () => {
    setOpenDialog(false);
  };
  const openText = (id) => {
    const idx = accordions.findIndex((el) => el.id === id);
    const show = !accordions[id].show;

    setAccordions((state) => {
      let newState = state;
      newState[id].show = show;
      return [...newState];
    });
  };

  return (
    <div className="w-full py-10 bg-[#eaeef3]">
      <Dialog
        fullScreen
        open={openDialog}
        onClose={closeDialog}
        TransitionComponent={Transition}
      >
        <Box>
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src="/img/back_button_black.png" onClick={closeDialog} />
            <Box
              sx={{
                margin: "16px 0 0 10px",
                fontSize: "25px",
                fontWeight: "bold",
              }}
            >
              {openDialog === "term" && "서비스 이용약관"}
              {openDialog === "policy" && "개인정보 수집 및 이용약관"}
              {openDialog === "faq" && "FAQ"}
            </Box>
          </Box>
          <Divider />
          <Box
            sx={{
              overflow: "scroll",
              padding: "0 20px",
            }}
          >
            {openDialog === "term" && <DialogText />}
            {openDialog === "policy" && <AgreeText />}
            {openDialog === "faq" && (
              <Box margin="20px">
                {accordions.map((item, index) => {
                  return (
                    <Box
                      onClick={() => openText(item.id, item.show)}
                      key={index}
                    >
                      <Box
                        sx={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          padding: "10px 0",
                        }}
                      >
                        {item.title}
                      </Box>
                      <Box
                        sx={{
                          display: "none",
                          // overflow: 'hidden',
                        }}
                        style={
                          accordions[index].show === true
                            ? {
                                maxHeight: "fit-content",
                                height: "fit-content",
                                display: "block",
                                fontSize: "14px",
                                whiteSpace: "pre-wrap",
                                marginBottom: "10px",
                              }
                            : null
                        }
                      >
                        {item.content}
                      </Box>
                      <Divider />
                    </Box>
                  );
                })}
              </Box>
            )}
          </Box>
        </Box>
      </Dialog>

      <ul className="flex justify-center text-sm opacity-70">
        {login.mcd !== "" && (
          <li
            className="px-2 border-r border-zinc-400"
            onClick={() => {
              Swal.fire({
                text: "로그아웃 하시겠습니까?",
                showCancelButton: true,
                confirmButtonText: "로그아웃",
                confirmButtonColor: "#0092a2",
                cancelButtonText: "취소",
                cancelButtonColor: "#FF0000",
              }).then((result) => {
                if (result.isConfirmed) {
                  localStorage.removeItem("token");
                  window.location.href = "/?cid=" + cid;
                }
              });
            }}
          >
            로그아웃
          </li>
        )}
        <li className="px-2 border-r border-zinc-400" onClick={() => setOpenDialog("term")}>
          이용약관
        </li>
        <li className="px-2 border-r font-bold border-zinc-400" onClick={() => setOpenDialog("policy")}>
          개인정보처리방침
        </li>
        <li className="px-2" onClick={() => setOpenDialog("faq")}>
          FAQ
        </li>
      </ul>
    </div>
  );
}
